import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, MessageCircle, Search } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { getSupportStatus } from "@/lib/hours";

const LINKS = [
  { to: "/", label: "Início" },
  { to: "/dispositivos", label: "Dispositivos" },
  { to: "/aplicativos", label: "Aplicativos" },
  { to: "/videos", label: "Vídeos" },
  { to: "/faq", label: "FAQ" },
  { to: "/suporte", label: "Suporte" },
  { to: "/status", label: "Status" },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const { openWhatsApp, settings } = useSettings();
  const st = getSupportStatus(settings);
  const loc = useLocation();
  const nav = useNavigate();

  const go = (to) => { setOpen(false); nav(to); };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#0B0F17]/85 border-b border-slate-800/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2.5 shrink-0">
          <img src="/logo.png" alt="Club Infinity" className="h-10 w-10 object-contain drop-shadow-[0_0_10px_rgba(0,229,255,0.35)]" />
          <span className="font-extrabold text-lg leading-none hidden sm:block">
            <span className="ci-gold-text">CLUB</span> <span className="ci-cyan-text">INFINITY</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                loc.pathname === l.to ? "text-cyan-300 bg-white/5" : "text-gray-300 hover:text-white hover:bg-white/5"
              }`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <span data-testid="header-whatsapp-status" className={`hidden md:inline-flex items-center gap-1.5 text-xs font-medium whitespace-nowrap ${st.online ? "text-emerald-300" : "text-gray-400"}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${st.online ? "bg-emerald-400" : "bg-gray-500"}`} />{st.label.replace(/^Hoje: .*?\. /, "Fechado hoje · ")}
          </span>
          <button onClick={() => openWhatsApp("header")} data-testid="header-whatsapp-btn"
            className="ci-btn-wa hidden sm:flex items-center gap-2 px-4 py-2.5 rounded-full text-white font-semibold text-sm hover:brightness-110 transition">
            <MessageCircle className="w-4 h-4" /> FALAR NO WHATSAPP
          </button>
          <button onClick={() => setOpen(!open)} data-testid="mobile-menu-btn"
            className="lg:hidden p-2 rounded-lg bg-white/5 text-white">
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-800 bg-[#0B0F17] px-4 py-3 space-y-1">
          {LINKS.map((l) => (
            <button key={l.to} onClick={() => go(l.to)} data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="w-full text-left px-3 py-2.5 rounded-lg text-gray-200 hover:bg-white/5 font-medium">
              {l.label}
            </button>
          ))}
          <button onClick={() => { setOpen(false); openWhatsApp("mobile-menu"); }}
            className="ci-btn-wa w-full flex items-center justify-center gap-2 px-4 py-3 rounded-full text-white font-semibold mt-2">
            <MessageCircle className="w-4 h-4" /> FALAR NO WHATSAPP
          </button>
        </div>
      )}
    </header>
  );
}
